import { Button, Dialog, DialogContent, DialogActions } from '@mui/material';

export interface TermsDialogTranslations {
  close: string;
  [key: string]: string;
}

interface TermsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  currentLanguage: string;
  timestamp: number;
  t: TermsDialogTranslations;
}

const TermsDialog: React.FC<TermsDialogProps> = ({ isOpen, onClose, currentLanguage, timestamp, t }) => (
  <Dialog open={isOpen} onClose={onClose}
    sx={{
      '& .MuiDialog-paper': {
        width: '80%',
        maxWidth: '600px',
        height: '80%',
      }
    }}>
    <DialogContent>
      <iframe
        src={currentLanguage === 'zh'
          ? `https://cms.hkstylist.com/商戶條款及細則/?t=${timestamp}`
          : `https://cms.hkstylist.com/business-terms-and-conditions/?t=${timestamp}`}
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        title="Terms and Conditions"
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        {t.close}
      </Button>
    </DialogActions>
  </Dialog>
);

export default TermsDialog;
